import { render } from "./BoxSVA.vue?vue&type=template&id=c876a54a"
import script from "./BoxSVA.vue?vue&type=script&lang=js"
export * from "./BoxSVA.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__